import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HouseIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.5278 22.0016H3.94257C2.77991 22.0016 1.83398 21.0558 1.83398 19.8931V8.79979C1.83398 8.39478 2.16233 8.06641 2.56741 8.06641C2.97248 8.06641 3.30083 8.39478 3.30083 8.79979V19.8931C3.30083 20.247 3.58869 20.5349 3.94257 20.5349H19.5278C19.8816 20.5349 20.1695 20.247 20.1695 19.8931V8.79979C20.1695 8.39478 20.4979 8.06641 20.9029 8.06641C21.308 8.06641 21.6364 8.39478 21.6364 8.79979V19.8931C21.6364 21.0557 20.6905 22.0016 19.5278 22.0016Z"
        fill="currentColor"
      />
      <path
        d="M22.736 11.3647C22.5483 11.3647 22.3607 11.2931 22.2175 11.1499L13.096 2.02904C12.3454 1.27843 11.1241 1.27843 10.3734 2.02904L1.25203 11.15C0.965629 11.4364 0.501236 11.4364 0.214835 11.15C-0.0716117 10.8636 -0.0716117 10.3992 0.214835 10.1128L9.33621 0.991856C10.6587 -0.330619 12.8107 -0.330619 14.1332 0.991856L23.2546 10.1128C23.5411 10.3992 23.5411 10.8635 23.2546 11.1499C23.1115 11.2931 22.9237 11.3647 22.736 11.3647Z"
        fill="currentColor"
      />
      <path
        d="M14.6691 21.9988H8.80178C8.3967 21.9988 8.06836 21.6705 8.06836 21.2655V14.7567C8.06836 13.493 9.09652 12.4648 10.3603 12.4648H13.1106C14.3744 12.4648 15.4026 13.493 15.4026 14.7567V21.2655C15.4026 21.6705 15.0742 21.9988 14.6691 21.9988ZM9.5352 20.5321H13.9357V14.7567C13.9357 14.3017 13.5656 13.9316 13.1106 13.9316H10.3603C9.90535 13.9316 9.5352 14.3017 9.5352 14.7567V20.5321Z"
        fill="currentColor"
      />
    </svg>
  )
})

HouseIcon.displayName = 'HouseIcon'
